"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var lodash_1 = require("lodash");
var commonBlockOptions_1 = require("@CommonFrontendBackend/StyleServiceV2/Config/BlockConfig/commonBlockOptions");
var commonTypes_1 = require("@CommonFrontendBackend/StyleServiceV2/Config/BlockConfig/commonTypes");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var StyleServiceV2_1 = require("@CommonFrontendBackend/StyleServiceV2/StyleServiceV2");
var mobx_react_1 = require("mobx-react");
var mobx_1 = require("mobx");
var ColorUtils_1 = require("../../../Common/Utils/ColorUtils/ColorUtils");
var fontSizeMapping_1 = require("@CommonFrontendBackend/StyleServiceV2/Config/BlockConfig/fontSizeMapping");
var kaleidoscope_2 = require("@qwilr/kaleidoscope");
var kaleidoscope_3 = require("@qwilr/kaleidoscope");
var ColorPalette_1 = __importDefault(require("Common/ColorPalette/ColorPalette"));
var GetBlockStyle_1 = require("@CommonFrontendBackend/StyleServiceV2/GetBlockStyle");
var CommonTextShortcut = (function (_super) {
    __extends(CommonTextShortcut, _super);
    function CommonTextShortcut(props) {
        var _this = _super.call(this, props) || this;
        _this.elementKeys = [
            commonTypes_1.TextElementType.H1,
            commonTypes_1.TextElementType.H2,
            commonTypes_1.TextElementType.P,
            commonTypes_1.TextElementType.Blockquote,
        ];
        _this.track = function (name, parameters) {
            var _a = _this.props, telemetry = _a.telemetry, blockStore = _a.blockStore;
            return telemetry.track(name, __assign({ block_styles_shortcuts_type: blockStore.blockType }, parameters), {
                blockIntercom: true,
            });
        };
        _this.handleFontSizeChange = function (fontSizeRef) {
            _this.selectedFontSizeRef = fontSizeRef;
            _this.setFontPropsForBlockTextElements(fontSizeRef);
            _this.track("Block Styles Shortcuts Changed", {
                block_styles_shortcuts_text_font_size: fontSizeRef,
            });
        };
        _this.handleTextColorChange = function (color) {
            _this.setTextColorPropsForBlockTextElement(color);
            _this.track("Block Styles Shortcuts Changed", {
                block_styles_shortcuts_text_color: (0, ColorUtils_1.getTelemetryColor)(color),
            });
        };
        _this.handleAlignmentChange = function (alignment) {
            var blockStyleStore = _this.props.blockStore.blockStyleStore;
            _this.elementKeys.forEach(function (type) {
                var newValue = (0, lodash_1.cloneDeep)(blockStyleStore.getElementStyle(type));
                newValue.alignment = alignment;
                blockStyleStore.setElementStyle(type, newValue);
            });
            if (blockStyleStore.model.blockType === commonTypes_1.BlockType.Accept) {
                var acceptButtonProps = (0, lodash_1.cloneDeep)(blockStyleStore.getElementStyle("acceptButton"));
                acceptButtonProps.alignment = alignment;
                blockStyleStore.setStylePropsByKey("acceptButton", acceptButtonProps);
            }
            _this.track("Block Styles Shortcuts Changed", {
                block_styles_shortcuts_text_alignment: alignment,
            });
        };
        _this.setFontPropsForBlockTextElements = function (fontSizeLabel) {
            var blockStyleStore = _this.props.blockStore.blockStyleStore;
            _this.elementKeys.forEach(function (type) {
                if (type === commonTypes_1.TextElementType.UnorderedListItem || type === commonTypes_1.TextElementType.OrderedListItem) {
                    return;
                }
                var newValue = (0, lodash_1.cloneDeep)(blockStyleStore.getElementStyle(type));
                newValue.size.abs = fontSizeMapping_1.fontSizeMappings[type][fontSizeLabel];
                newValue.size.themeRef = fontSizeLabel;
                blockStyleStore.setElementStyle(type, newValue);
            });
        };
        _this.setTextColorPropsForBlockTextElement = function (color) {
            var blockStyleStore = _this.props.blockStore.blockStyleStore;
            _this.elementKeys.forEach(function (type) {
                var newValue = (0, lodash_1.cloneDeep)(blockStyleStore.getElementStyle(type));
                newValue.color.abs = color.value;
                newValue.color.themeIndex = color.themeIndex;
                blockStyleStore.setElementStyle(type, newValue);
            });
        };
        var blockStyleStore = props.blockStore.blockStyleStore;
        _this.selectedFontSizeRef = (0, StyleServiceV2_1.getCombinedGroupedSize)(blockStyleStore.model);
        return _this;
    }
    CommonTextShortcut.prototype.render = function () {
        var _a = this.props, blockStyleStore = _a.blockStore.blockStyleStore, colors = _a.colors;
        var selectedFontSizeRef = this.selectedFontSizeRef;
        var combinedColorThemeIndex = (0, StyleServiceV2_1.getCombinedColorThemeIndex)(blockStyleStore.model);
        var selectedThemeIndex = combinedColorThemeIndex === null ? null : Number(combinedColorThemeIndex);
        var selectedColor = (0, StyleServiceV2_1.getCombinedColor)(blockStyleStore.model);
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { className: "style-shortcut__section" },
                react_1.default.createElement("div", { className: "style-shortcut__section-title label" }, "Color"),
                react_1.default.createElement("div", { className: "style-shortcut__buttons-container" },
                    react_1.default.createElement(ColorPalette_1.default, { onColorChange: this.handleTextColorChange, presetColors: colors, selectedColor: selectedColor
                            ? (0, GetBlockStyle_1.sanitizeColor)({ value: selectedColor, themeIndex: selectedThemeIndex }, colors)
                            : undefined, theme: "light", type: "content" }))),
            react_1.default.createElement("div", { className: "style-shortcut__section" },
                react_1.default.createElement("div", { className: "style-shortcut__buttons-container" },
                    react_1.default.createElement(kaleidoscope_1.SegmentedControl, { label: "font size", size: kaleidoscope_3.SegmentedControlSize.Medium, options: commonBlockOptions_1.fontSizeOptions, selectedValue: selectedFontSizeRef, onClickHandler: this.handleFontSizeChange }))),
            react_1.default.createElement("div", { className: "style-shortcut__section style-shortcut__section--alignment" },
                react_1.default.createElement(kaleidoscope_1.SegmentedControl, { label: "Alignment", size: kaleidoscope_3.SegmentedControlSize.Medium, options: commonBlockOptions_1.alignmentOptions, selectedValue: (0, StyleServiceV2_1.getCombinedAlignment)(blockStyleStore.model), onClickHandler: this.handleAlignmentChange })),
            react_1.default.createElement("div", { className: "style-shortcut__section" },
                react_1.default.createElement(kaleidoscope_2.Alert, { alignment: kaleidoscope_2.AlertAlignment.Center, heading: "Want more control?" }, "Highlight text to bring up the toolbar, and click the styles icon"))));
    };
    var _a;
    __decorate([
        mobx_1.observable,
        __metadata("design:type", typeof (_a = typeof commonTypes_1.OptionLabelTypes !== "undefined" && commonTypes_1.OptionLabelTypes) === "function" ? _a : Object)
    ], CommonTextShortcut.prototype, "selectedFontSizeRef", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], CommonTextShortcut.prototype, "handleFontSizeChange", void 0);
    CommonTextShortcut = __decorate([
        mobx_react_1.observer,
        __metadata("design:paramtypes", [Object])
    ], CommonTextShortcut);
    return CommonTextShortcut;
}(react_1.default.Component));
exports.default = CommonTextShortcut;
